import React, { useState } from 'react';
import { WideLayout } from '../../../shared/layout/widelayout';
import { TitledPanel } from '../../../shared/ui/dashboard/titledPanel/titledPanel';
import { useLayoutStore, usePortalStore } from '../../../stores/portalStore';
import { TabItem } from '../../../shared/ui/tab';
import { BasketPage } from '../components/basket/basket';
import { LargeTile } from '../../../shared/ui/grid/gridsystem';
import { useResponsive } from '../../../hooks/useResponsive';
import { QuestionPage } from '../components/question/question';
import { FlowPage } from '../components/flowbuilder/flowBuilder';
import { ProductFlowPage } from '../components/productFlow/productFlow';
import { CompanyBasketsPage } from '../components/company/companyBaskets';

export const BasketManagerPage: React.FC = () => {
  const currentUser = usePortalStore((state: any) => state.currentUser);

  const content = currentUser?.isAdmin ? (
    <MainPanels />
  ) : (
    <TitledPanel
      height="100%"
      title="Acesso Negado"
      outlet={<h3>Você não tem permissão para acessar esta página.</h3>}
    />
  );

  return <WideLayout outlet={content} forceWebView={true} />;
};

const MainPanels = () => {
  const [currentConfigPage, setCurrentConfigPage] = useState(0);
  // Fluxo destacado ao vir da aba Empresas e empresa escolhida: mantidos aqui
  // porque as abas são remontadas (e recarregam os dados) a cada troca.
  const [highlightFlowId, setHighlightFlowId] = useState<number>();
  const [companyCnpj, setCompanyCnpj] = useState<string>();
  const { isDesktop } = useResponsive();
  const contentWidth = useLayoutStore((state) => state.contentWidth);
  const contentHeight = useLayoutStore((state) => state.contentHeight);
  const containerWidth = isDesktop && contentWidth ? contentWidth : '100%';
  const containerHeight =
    isDesktop && contentHeight ? contentHeight - 35 : '90vh';
  // Ordem do fluxo de criação: cestas → perguntas → fluxos → produtos → empresas.
  const tabs = [
    {
      label: 'Balaios',
      component: <BasketPage />,
    },
    {
      label: 'Perguntas',
      component: <QuestionPage />,
    },
    {
      label: 'Fluxos',
      component: <FlowPage highlightFlowId={highlightFlowId} />,
    },
    {
      label: 'Produtos',
      component: <ProductFlowPage />,
    },
    {
      label: 'Empresas',
      component: (
        <CompanyBasketsPage
          initialCnpj={companyCnpj}
          onCompanyChange={setCompanyCnpj}
          onOpenFlow={(flowId) => {
            setHighlightFlowId(flowId);
            setCurrentConfigPage(
              tabs.findIndex((tab) => tab.label === 'Fluxos')
            );
          }}
        />
      ),
    },
  ];

  return (
    <LargeTile
      style={{
        maxWidth: containerWidth,
        margin: '15px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <TitledPanel
        title="Balaios"
        outlet={
          <div>
            <div style={{ display: 'flex' }}>
              {tabs.map((tab, index) => (
                <TabItem
                  key={index}
                  style={{
                    color: currentConfigPage === index ? '#318300' : '#666',
                    fontWeight: currentConfigPage === index ? 700 : 500,
                    borderBottom:
                      currentConfigPage === index
                        ? '3px solid #58a61e'
                        : '3px solid transparent',
                    opacity: currentConfigPage === index ? 1 : 0.7,
                  }}
                  onClick={() => {
                    setHighlightFlowId(undefined);
                    setCurrentConfigPage(index);
                  }}
                >
                  {tab.label}
                </TabItem>
              ))}
            </div>
            <br />
            <div>
              <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                {tabs[currentConfigPage]?.component}
              </div>
            </div>
          </div>
        }
      />
    </LargeTile>
  );
};
